// extracted by css-extract-rspack-plugin
export default {"drawer":"PC0_UBcVV_8Fb5bz"};